<script lang="ts">
  import CopyWrapper from "components/Common/CopyWrapper.svelte";
  import Dialog from "components/Common/Dialog.svelte";
  import { getBildebankenHost } from "config";
  import { displayName } from "./collectionOperations";
  import { orgGarbage, orgLink } from "@nrk/origo";
  import { user } from "services/api";

  export let collection;
  export let currentUser;

  export let removeUserFromCollection = async (collectionId: string, userId: string) => {};
  $: isOwner = collection?.owner === currentUser?.id;
  let isDeleting: boolean = false;

  async function removeUser(userId: string) {
    isDeleting = true;
    await removeUserFromCollection(collection.id, userId);
    isDeleting = false;
  }

  function onConfirm() {}

  $: shareLink = collection ? createShareLink(collection.id) : "";

  let linkCopied = false;

  function copyLink() {
    navigator.clipboard.writeText(shareLink).then(() => {
      linkCopied = true;
      setTimeout(() => {
        linkCopied = false;
      }, 1000);
    });
  }

  function createShareLink(collectionId) {
    const host = getBildebankenHost();
    host.pathname = "collections";
    host.searchParams.append("share", collectionId);
    return host.href;
  }
</script>

{#if collection}
  <Dialog
    headerText={"Del samling"}
    confirmText={"Ferdig"}
    id="share-collection-dialog"
    {onConfirm}
  >
    <p>
      Ønsker du å dele tilgangen til <strong>{displayName(collection)}</strong>? Personer som
      trykker på lenken vil automatisk få tilgang til å redigere og vise innholdet i samlingen.
    </p>
    <label for="link-copy-input">Lenke</label>
    <div class="link-copy-input-wrapper">
      <CopyWrapper text={shareLink} title="Kopier delingslenke">
        <input id="link-copy-input" class="org-input" readonly value={shareLink} />
      </CopyWrapper>
    </div>

    <p class="org-muted">
      Bilder som ikke er tilgjengelige for alle i NRK vil ikke vises i samlingen for andre enn
      opplaster.
    </p>
    {#if collection.visibleTo?.users?.length}
      <label for="member-list">Medlemmer</label>
      <div class="member-list" id="member-list">
        {#each collection.visibleTo.users as member}
          {#await user(member) then userData}
            <div>
              <span>{userData.givenName} {userData.familyName}</span>
              <span
                ><button
                  type="button"
                  on:click={() => removeUser(member)}
                  disabled={!isOwner || isDeleting}
                  aria-label={`Fjern ${userData.givenName} ${userData.familyName} fra samlingen`}
                  class="org-button org-button--suggestive">{@html orgGarbage}</button
                ></span
              >
            </div>
          {/await}
        {/each}
      </div>
    {/if}
    <button
      class="org-button org-button--suggestive"
      type="button"
      slot="toolbar-buttons-left"
      on:click={copyLink}
    >
      {@html orgLink}
      {linkCopied ? "Lenke kopiert" : "Kopier lenke"}
    </button>
  </Dialog>
{/if}

<style>
  .member-list {
    display: flex;
    flex-direction: column;
    gap: var(--org-small);
    margin-bottom: var(--org-medium);
    background: var(--color-surface-primary);
    border-style: solid;
    max-height: 8rem;
    overflow-y: scroll;
    border-width: 1px;
    border-color: var(--org-color-gray-600);
    padding: var(--org-small);
  }

  .member-list > div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .link-copy-input-wrapper {
    margin-top: 0px;
    display: flex;
    position: relative;
    align-items: flex-end;
  }

  .link-copy-input-wrapper :global(.wrapper) {
    display: flex;
    align-items: center;
    width: 100%;
  }

  .link-copy-input-wrapper :global(.content-wrapper) {
    display: block;
    flex: 1;
  }

  .link-copy-input-wrapper input {
    width: 100%;
    padding-right: 36px;
  }
</style>
